module.exports = __webpack_public_path__ + "img/header-engagementRings050Carat.9d68b2b.webp";